import systemApi from "@/apis/components/SystemAPI";
import commonFn from "@/commons/commonFunction";

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: {
        /**
         * Cờ đang xử lý
         */     
        Loading: false,
        
        userInfor: {},  
        
        listRole: {},
        
        userOptions: {}
    },
	mutations: {

        /**
         * Cập nhật context
         * @param {*} state
         * @param {*} payload
         */
        updateContext(state, payload) {
          let data = payload.data.Data;
          state.userInfor = {...data.UserData};
          state.listRole = {...data.Permissions};
          state.userOptions = {...data.UserOptions};
        },
    },
	actions: {

        /**
         * Lấy thông tin config cho client làm việc
         * @param {*} context
         */
        async getContextData(context) {
          try {
            let res = await systemApi.getCurrentUser();
      
            context.commit("updateContext", res);
          } catch (ex) {
            commonFn.errorLogging("Lỗi lấy thông tin config:: ", ex);
          }
        }
    },
	getters: {}
};
